import Tournament from '~/components/Tournament/Tournament';

const CreateTournament = () => {
  return <Tournament />;
};

export default CreateTournament;
